<template>
    <div class="login">
        <!-- Обертка для формы -->
        <div class="login-container">
            <div
                class="login-form"
            >
                <img
                    src="/images/impulse_icon.png"
                    alt="Логотип"
                >
                <span class="app-title">АРМ Врача</span>

                <div
                    v-if="errorMessage"
                    class="error-message"
                >
                    {{ errorMessage }}
                </div>

                <!-- <div
                    v-if="
                        !blockStatusUser
                            && counterButtonSendContinue < 3
                            && counterButtonSendContinue !== 0
                    "
                    class="error-message"
                >
                    {{ `${errorMessageUser}: ${counterButtonSendContinue}` }}
                </div> -->

                <a-form
                    ref="formRef"
                    :model="formState"
                    :rules="formValidationRules"
                    @keyup.enter="onSubmit"
                >
                    <a-form-item name="login">
                        <a-input
                            v-model:value="formState.login"
                            placeholder="Логин"
                        />
                    </a-form-item>
                    <a-form-item name="password">
                        <a-input-password
                            v-model:value="formState.password"
                            placeholder="Пароль"
                        />
                    </a-form-item>
                    <a-form-item>
                        <a-button
                            type="primary"
                            data-test-id="login-btn"
                            :disabled="isValid"
                            @click="onSubmit"
                        >
                            Войти
                        </a-button>
                    </a-form-item>
                </a-form>

                <div class="additional-buttons">
                    <a-button v-if="hideForgotPasswordButton" @click="onForgotPassword">
                        Забыли пароль?
                    </a-button>
                    <!-- <a-button @click="onOldAuth">Старая авторизация</a-button> -->
                </div>
            </div>
        </div>
        <app-version />
    </div>
</template>

<script>
import { defineComponent } from 'vue';
import {
    showErrorNotification,
    RouterConfig,
    detectOS,
    detectBrowser,
    detectIP,
} from '@/utils';
import AppVersion from '@/components/authorization/AppVersion.vue';

export default defineComponent({
    name: 'AuthorizationSignIn',
    components: {
        AppVersion,
    },
    data() {
        return {
            formState: {
                login: '',
                password: '',
            },
            formValidationRules: {
                login: [{ required: true, message: 'Обязательное поле' }],
                password: [{ required: true, message: 'Обязательное поле' }],
            },
            errorMessage: '',
            /**
             * Флаг вывода контейнера с ошибкой
             */
            // errorStatusUser: false,
            /**
             * Текст ошибки при невернном вводе пин-код
             */
            errorMessageUser: 'Осталось попыток',
            /**
             * TODO
             * "Статус блокировки"
             * заблокирован ли пользователь
             */
            blockStatusUser: false,
            /**
             * TODO
             * "Счетчик количества попыток отправки пин-кода"
             * Кнопка "Продолжить"
             * оставшееся количество попыток отправки пин-кода до блокировки по кнопке
             */
            counterButtonSendContinue: 3,
            /**
             * Показать/Скрыть кнопку "Забыли пароль?"
             */
            hideForgotPasswordButton: true,
        };
    },
    computed: {
        isValid() {
            return !(this.formState.login && this.formState.password);
        },
    },
    mounted() {
        this.$nextTick(() => {
            if ('parametrs' in localStorage && Object.keys(localStorage.parametrs).length) {
                const { otpGlobalSetup } = JSON.parse(localStorage.parametrs);

                if (!otpGlobalSetup) {
                    this.hideForgotPasswordButton = otpGlobalSetup;
                }
            }
        });
    },
    methods: {
        onSubmit() {
            this.$refs.formRef.validate().then(({ login, password }) => {
                this.login(login, password);
            }, () => {});
        },

        async login(username, password) {
            try {
                const { deviceId, staffId } = localStorage;
                const os = detectOS();
                const browser = detectBrowser();
                const ip = await detectIP();
                const response = await this.$http.post('/v2/auth/login', {
                    username,
                    password,
                    deviceId,
                    userId: staffId,
                    os,
                    browser,
                    ip,
                });

                const {
                    user = {},
                } = response.data;

                if (Object.keys(user).length) {
                    const {
                        name,
                        previewFileId,
                        clinics,
                        id,
                        chatUserId,
                        chatUserToken,
                        timePasswordExpire,
                    } = user || {};

                    localStorage.username = name;
                    localStorage.previewFileId = previewFileId;
                    localStorage.clinics = clinics;
                    localStorage.staffId = id;
                    localStorage.chatUserId = chatUserId;
                    localStorage.chatUserToken = chatUserToken;
                    localStorage.timePasswordExpire = timePasswordExpire;
                }

                localStorage[RouterConfig.loginSignIn.name] = JSON.stringify(response.data);
                localStorage.parametrs = JSON.stringify(response.data);

                this.errorMessage = '';

                if ('parametrs' in localStorage && Object.keys(localStorage.parametrs).length) {
                    const {
                        pinGlobalSetup,
                        pinSetup,
                        otpGlobalSetup,
                        otpSetup,
                    } = JSON.parse(localStorage.parametrs);

                    if (pinGlobalSetup && pinSetup) {
                        if (otpGlobalSetup && otpSetup) {
                            this.$router.push({ name: RouterConfig.loginSignInVerifyEmail.name });
                        } else {
                            this.$router.push({ name: RouterConfig.loginPinUp.name });
                        }
                    } else if (otpGlobalSetup && otpSetup) {
                        this.$router.push({ name: RouterConfig.loginSignInVerifyEmail.name });
                    } else {
                        localStorage.LoggedIn = true;
                        // this.$router.push({ name: 'main' });
                        if (user?.changePassword) {
                            this.$router.push({ name: RouterConfig.changePassword.name });
                        } else {
                            this.$router.push({ name: 'main' });
                        }
                    }
                } else {
                    this.$router.push({ name: RouterConfig.loginSignInVerifyEmail.name });
                }
            } catch (error) {
                if (error.response?.data?.msg) {
                    this.errorMessage = error.response.data.msg;

                    if (error.response.data.msg.includes('Доступ')) {
                        this.blockStatusUser = true;
                    } else if (this.counterButtonSendContinue > 0) {
                        this.counterButtonSendContinue -= 1;
                    }
                } else {
                    showErrorNotification('Ошибка. Попробуйте позже', 5000);
                }
            }
        },

        onForgotPassword() {
            this.$router.push({ name: RouterConfig.forgot.name });
        },

        onOldAuth() {
            this.$router.push({ name: RouterConfig.loginOld });
        },
    },
});
</script>

<style lang="scss" scoped>
.login {
    background: url("/images/login-wall.jpg") center center / cover no-repeat rgb(255, 255, 255);
    height: 100%;
    display: flex;
}

.login-container {
    margin: auto;
    max-width: 460px;
    width: 100%;
    border-radius: 4px;
    position: relative;
}

.app-title {
    display: block;
    color: #00706c;
    font-weight: 600;
    font-size: 14px;
    font-family: Arial, sans-serif !important;
    margin-bottom: 20px;
    margin-top: 0px;
    text-align: center;
}

.login-form {
    position: relative;
    margin: auto;
    max-width: 100%;
    border-radius: 8px;
    border: 1px solid #e8e8e8;
    padding: 20px;
    background-color: transparent;
    z-index: 1;
    overflow: hidden;

    &::before {
        content: '';
        position: absolute;
        inset: 0;
        background-color: #fff;
        opacity: 0.8;
        z-index: -1;
    }

    .ant-form-item {
        margin-block: 8px;

        &:last-child {
            margin-top: 20px;
            margin-bottom: 0;
        }
    }

    .ant-form-explain {
        margin-bottom: -17px;
        text-align: left;
        font-size: 13px;
    }

    img {
        display: block;
        margin: 0 auto 4px;
        max-width: 100px;
    }

    .additional-buttons {
        display: flex;
        flex-direction: column;
        gap: 10px;

        .ant-btn {
            text-align: center;
            padding: 0;
            width: fit-content;
            height: auto;
            text-decoration: none;
            color: #83b274;
            font-size: 14px;
            margin: 0 auto;
            border: none;
            background-color: transparent;
            box-shadow: none;

            &:disabled,
            &[disabled] {
                pointer-events: none;
                opacity: 0.5;
            }

            &:hover {
                color: #74b85d;
            }
        }
    }

    & .ant-btn.ant-btn-primary {
        min-width: 110px;
        height: auto;
        font-size: 14px;
        margin-bottom: 18px;

        padding: 7px 20px;
        background-color: #8dc07c;
        text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.2);
        box-shadow: 0px 0px 4px rgba(46, 75, 37, 0.4);
        border: none;
        color: #fff;

        &:disabled,
        &[disabled] {
            pointer-events: none;
            opacity: 0.5;
        }

        &:hover {
            background-color: #74b85d;
        }
    }

    & .ant-input,
    & .ant-input-password {
        height: 36px;
        border-radius: 4px;

        &:hover {
            border-color: #83b274;
        }

        &:focus,
        &:has(input:focus) {
            border-color: #83b274;
            box-shadow: 0 0 0 2px rgb(131, 178, 116, 0.2);
        }
    }

    & .ant-form-item-has-error .ant-input,
    & .ant-form-item-has-error .ant-input-password {
        border-color: #ff4d4f;
        box-shadow: 0 0 0 2px rgba(255, 77, 77, 0.2);
    }

    :deep(.ant-form-item-explain)  {
        width: fit-content;
    }

    .error-message {
        color: #ff4d4f;
        font-size: 14px;
        margin-bottom: 8px;
        text-align: left;
        max-width: 100%;
        word-break: break-word;
        white-space: pre-wrap;
        line-height: 1.4;
        padding: 8px 10px;
        background: #fff5f5;
        border: 1px solid #ffccc7;
        border-radius: 4px;
        overflow-x: hidden;
    }
}
</style>
